import { Accordion, Info, Layer, RadioButton } from 'ui/components'
import { CRBLicenses } from '~bank-crb-monitor/types'

import { useCRBPanelContext } from '../../CRBPanelContext'
import { Address } from './Address'
import { Details } from './Details'

import { s } from './styles'

export const License = (props: { license: CRBLicenses }) => {
  const { selectedLicense, setSelectedLicense } = useCRBPanelContext()
  const { license } = props
  const { id, licensee, licenseIdentifier, addresses } = license

  return (
    <Layer rounded shadowed stretch={false} key={id} style={{ marginBottom: '20px' }}>
      <s.LicenseHead>
        <Info label="Licensee">
          <h4>{licensee}</h4>
        </Info>
        <div>
          <RadioButton
            checked={selectedLicense === id}
            label="License #"
            value={id}
            onChange={() => {
              setSelectedLicense(selectedLicense === id ? 0 : id)
            }}
            name="licenses"
          />
          <s.LicenseNumber>{licenseIdentifier}</s.LicenseNumber>
        </div>
      </s.LicenseHead>
      <Accordion title="Details" bottomPadding="small" children={<Details license={license} />} />

      {addresses.map((address, index) => {
        const { street } = address

        return <Address address={address} key={`${id}-${street}-${index}`} />
      })}
    </Layer>
  )
}
